import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "log",
  "use": "log-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"log\"><path d=\"M27 29.75H11A2.75 2.75 0 0 1 8.25 27v-.45a7.75 7.75 0 0 1 0-15.1V5A2.75 2.75 0 0 1 11 2.25h11.17a2.74 2.74 0 0 1 1.95.81l4.82 4.82a2.74 2.74 0 0 1 .81 2V27A2.75 2.75 0 0 1 27 29.75zm-17.25-3V27A1.25 1.25 0 0 0 11 28.25h16A1.25 1.25 0 0 0 28.25 27V10.75H24A2.75 2.75 0 0 1 21.25 8V3.75H11A1.25 1.25 0 0 0 9.75 5v6.25H10a7.75 7.75 0 0 1 0 15.5zm.25-14A6.25 6.25 0 1 0 16.25 19 6.25 6.25 0 0 0 10 12.75zm12.75-8.86V8A1.25 1.25 0 0 0 24 9.25h4.11a1.39 1.39 0 0 0-.23-.31l-4.82-4.82a1.39 1.39 0 0 0-.31-.23zM25 22.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5zm-16.5-1.5A.74.74 0 0 1 8 21a.75.75 0 0 1 0-1l1.28-1.28V16a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.22.53L9 21a.74.74 0 0 1-.5.25zm16.5-2.5h-4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5zm0-4h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5zm-7-4h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/log.svg
// module id = RFpB
// module chunks = 1